import { render, staticRenderFns } from "./TheTopbarLogo.vue?vue&type=template&id=540bbb2e&scoped=true"
import script from "./TheTopbarLogo.vue?vue&type=script&lang=js"
export * from "./TheTopbarLogo.vue?vue&type=script&lang=js"
import style0 from "./TheTopbarLogo.vue?vue&type=style&index=0&id=540bbb2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540bbb2e",
  null
  
)

export default component.exports